<div class="loading">
  @if (loadingService.isLoading()) {
    <div class="layer"></div>

    <div class="content">
      <div class="spinner-border text-primary mask-spinner"></div>
    </div>
  }

  <div class="content-wrapper" [class.blurred]="loadingService.isLoading()">
    <ng-content />
  </div>
</div>
